<template>
  <update-business-member-field
    title="Mailing Address"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-text-field class="tw-col-span-2 tw-mt-4 sm:tw-mt-0" label="Line 1" placeholder="Enter line 1" v-model="mailingAddressLine1" required />
    <base-text-field label="Line 2" placeholder="Enter line 2" v-model="mailingAddressLine2" />
    <base-text-field label="City" placeholder="Enter city" v-model="mailingCity" required class="tw-mt-5" />
    <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-x-4">
      <base-select label="State" placeholder="Select state" :options="STATE_OPTIONS" label-key="name" v-model="mailingState" required />
      <base-text-field label="Zip Code" placeholder="Enter zip code" v-model="mailingPostalCode" required />
    </div>
    <template #value>
      <div v-if="member.mailingAddressLine1 || member.mailingAddressLine2 || lastAddressLine">
        <div v-if="member.mailingAddressLine1">{{ member.mailingAddressLine1 }}</div>
        <div v-if="member.mailingAddressLine2">{{ member.mailingAddressLine2 }}</div>
        <div v-if="lastAddressLine">{{ lastAddressLine }}</div>
      </div>
      <div v-else>-</div>
    </template>
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";
import { STATE_OPTIONS } from "@/constants/constants";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      STATE_OPTIONS,
      mailingAddressLine1: "",
      mailingAddressLine2: "",
      mailingCity: "",
      mailingState: "",
      mailingPostalCode: "",
    };
  },
  computed: {
    lastAddressLine() {
      let line = "";

      if (this.member.mailingCity) {
        line += this.member.mailingCity;
      }
      if (this.member.mailingState) {
        if (line) {
          line += ", ";
        }
        line += this.member.mailingState;
      }
      if (this.member.mailingPostalCode) {
        if (line) {
          line += ", ";
        }
        line += this.member.mailingPostalCode;
      }

      return line;
    },
  },
  methods: {
    handleIsEditing($event) {
      this.phone = this.member.phone;
      this.mailingAddressLine1 = this.member.mailingAddressLine1;
      this.mailingAddressLine2 = this.member.mailingAddressLine2;
      this.mailingCity = this.member.mailingCity;
      this.mailingState = this.member.mailingState;
      this.mailingPostalCode = this.member.mailingPostalCode;

      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        mailingAddressLine1: this.mailingAddressLine1,
        mailingAddressLine2: this.mailingAddressLine2,
        mailingCity: this.mailingCity,
        mailingState: this.mailingState,
        mailingPostalCode: this.mailingPostalCode,
      });
    },
  },
};
</script>
